import React, { useMemo } from 'react';
import { IProductReview } from '../../../../entities-generated/common/product-review';
import { IProductTexture } from '../../../../entities-generated/common/product-texture';
import { ProductDetailPanelContentMobile } from './mobile';
import { ProductDetailPanelContentDesktop } from './desktop';
import { IBrowserImage } from '../../../../framework/components/bwj-image-browser';
import { BwjViewManager, BwjViewState } from '../../../../framework/components/bwj-view-manager';
import { DoorRecommendation } from '../../../../entities-generated/common/door-recommendation';

export interface IProductDetailPanelDisplayProps {
  id: string;
  brand: string;
  title: string;
  price: number;
  averageRating?: number | undefined;
  rating?: IProductReview | undefined;
  keyFeatures: string[];
  includedServices?: string[] | undefined;
  variants: IProductTexture[];
  variantDescriptor: string;
  chooseProductButtonText: string;
  recommendation?: DoorRecommendation | undefined;
  priceChange?: number | undefined;
  onProductChosen: (variant: IProductTexture) => void;
  chooseVariantButtonText: string;
  onIncludedServicesOverlayRequested?: ((included: string[]) => void) | undefined;
}

export interface IProductDetailPanelContentProps extends IProductDetailPanelDisplayProps {
  imageUrls: IBrowserImage[];
  displayedImageIndex: number;
  onDisplayedIndexChanged: (index: number) => void;
  contentWidth: number;
  selectedVariant: IProductTexture | null;
  onVariantSelected: (variant: IProductTexture) => void;
  onVariableOptionsVisibilityChange: (visible: boolean) => void;
  verticalScrollInfo: { scrollY: number, vpHeight: number, containerSelector: string };
}

export const ProductDetailPanelContent: React.FunctionComponent<IProductDetailPanelContentProps> = (props) => {
  const { contentWidth } = props;
  const viewState = useMemo(() => {
    return contentWidth === 0 ? BwjViewState.Loading : BwjViewState.Ready;
  }, [contentWidth]);

  return (
    <BwjViewManager
      state={viewState}
      loadingState={{
        message: '',
      }}
    >
      {props.contentWidth < 620 ?
      <ProductDetailPanelContentMobile {...props} />
      :
      <ProductDetailPanelContentDesktop {...props} />}
    </BwjViewManager>
  );
};
